export default __webpack_public_path__ + "static/22-43c72e774cdb807e8c70991abb627802.png";